import GoTrueAdminApi from './GoTrueAdminApi';
import GoTrueClient from './GoTrueClient';
export { GoTrueAdminApi, GoTrueClient };
export * from './lib/types';
export * from './lib/errors';
//# sourceMappingURL=index.js.map